import { AnyID, SceneObjects, Walls, WallsID } from '@types'

export default function isWall(wall?: SceneObjects | string): wall is Walls {
  if (typeof wall === 'string') return wall.startsWith('walls_')
  return !!wall && wall?.type === 'walls'
}

export function isWallID(wallID: AnyID): wallID is WallsID {
  return wallID && wallID.startsWith('walls_')
}
